import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { showQuizPickerModal } from '@/shared/features/quiz-picker';

/**
 * `다음 퀴즈 이어풀기` 에 연결할 퀴즈를 고른다. `showQuizPickerModal` 을 빌드 폼이 기대하는 모양으로 감싼다.
 *
 * `rootOnly: false` — 다음 퀴즈는 폴더 안에 있든 밖에 있든 이어 붙일 수 있다.
 * 잠긴 퀴즈는 고를 수 없다(`lockedSelectLabel`) — 골라도 재생에서 걸러진다.
 */
export const useOpenNextQuizsetSelectModal = () => {
  const {
    t
  } = useTranslation(['build']);
  return async ({
    excludeQuizsetIds
  }: {
    excludeQuizsetIds: string[];
  }) => {
    let selectedQuizsetId: string | undefined;
    await showQuizPickerModal({
      title: t('build:nextQuizModal.title'),
      selectLabel: t('build:nextQuizModal.select'),
      lockedSelectLabel: t('build:nextQuizModal.lockQuiz'),
      rootOnly: false,
      excludeQuizsetIds,
      onSelect: quiz => {
        logger.track('selectNextQuizset');
        selectedQuizsetId = quiz.id;
      },
      onPreview: () => logger.track('previewNextQuizset', {
        from: 'selectModal'
      })
    });
    return selectedQuizsetId;
  };
};